import React from 'react';
import { Link } from 'react-router-dom';
import { FaFemale, FaHandsHelping, FaTree, FaGraduationCap, FaMedal } from 'react-icons/fa';
import '../css/About.css';

const About = () => {
  return (
    <div className="about">
      {/* HERO */}
      <section style={{
        background: 'linear-gradient(rgba(138,79,255,0.9), rgba(0,0,0,0.7)), url("/images/ethiopia-about.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        padding: '120px 0',
        marginTop: '-80px'
      }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '3.5rem', fontWeight: 700, marginBottom: '20px' }}>Our Story</h1>
          <p style={{ fontSize: '1.3rem', maxWidth: '800px', margin: '0 auto', opacity: 0.95 }}>
            Founded in Addis Ababa to change how the world sees Ethiopia —
            and how Ethiopian women see themselves.
          </p>
        </div>
      </section>

      {/* MISSION */}
      <section style={{ padding: '100px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'center' }}>
            <div>
              <h2 style={{ color: '#8a4fff', fontSize: '1rem', letterSpacing: '2px', marginBottom: '15px' }}>OUR MISSION</h2>
              <h3 style={{ fontSize: '2.2rem', fontWeight: 700, marginBottom: '25px', color: '#1a1e24' }}>
                Empowering Women, Transforming Tourism
              </h3>
              <p style={{ color: '#555', lineHeight: '1.8', marginBottom: '25px' }}>
                Encourage Women Ethiopia exists at the intersection of women's empowerment
                and sustainable tourism. We believe the most authentic stories of Ethiopia
                are told by Ethiopian women - and they deserve to be the leaders, guides,
                and beneficiaries of the tourism economy.
              </p>
              <p style={{ color: '#555', lineHeight: '1.8', marginBottom: '35px' }}>
                Since 2023, we've trained and employed 35+ female guides, supported 8 women's
                cooperatives across Ethiopia, and welcomed over 2,000 travelers to experience
                our homeland through women's eyes.
              </p>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ background: '#f0e6ff', padding: '20px', borderRadius: '12px', flex: 1 }}>
                  <h4 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#8a4fff' }}>35+</h4>
                  <p style={{ color: '#666', fontSize: '0.95rem' }}>Female Guides</p>
                </div>
                <div style={{ background: '#f0e6ff', padding: '20px', borderRadius: '12px', flex: 1 }}>
                  <h4 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#8a4fff' }}>8</h4>
                  <p style={{ color: '#666', fontSize: '0.95rem' }}>Women's Co-ops</p>
                </div>
                <div style={{ background: '#f0e6ff', padding: '20px', borderRadius: '12px', flex: 1 }}>
                  <h4 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#8a4fff' }}>2K+</h4>
                  <p style={{ color: '#666', fontSize: '0.95rem' }}>Travelers</p>
                </div>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
              <div style={{ background: '#8a4fff', padding: '30px', borderRadius: '20px', color: 'white', aspectRatio: '1' }}>
                <FaMedal size={40} />
                <h4 style={{ marginTop: '20px', fontSize: '1.3rem' }}>Award Winner</h4>
                <p style={{ fontSize: '0.9rem', opacity: 0.9 }}>UNWTO Women in Tourism 2024</p>
              </div>
              <div style={{ background: '#1a1e24', padding: '30px', borderRadius: '20px', color: 'white', aspectRatio: '1' }}>
                <FaTree size={40} />
                <h4 style={{ marginTop: '20px', fontSize: '1.3rem' }}>Eco-Certified</h4>
                <p style={{ fontSize: '0.9rem', opacity: 0.9 }}>Sustainable Travel Partner</p>
              </div>
              <div style={{ background: '#1a1e24', padding: '30px', borderRadius: '20px', color: 'white', aspectRatio: '1' }}>
                <FaHandsHelping size={40} />
                <h4 style={{ marginTop: '20px', fontSize: '1.3rem' }}>Community Impact</h4>
                <p style={{ fontSize: '0.9rem', opacity: 0.9 }}>1 ETH = 1 Tree Planted</p>
              </div>
              <div style={{ background: '#8a4fff', padding: '30px', borderRadius: '20px', color: 'white', aspectRatio: '1' }}>
                <FaGraduationCap size={40} />
                <h4 style={{ marginTop: '20px', fontSize: '1.3rem' }}>Guide Academy</h4>
                <p style={{ fontSize: '0.9rem', opacity: 0.9 }}>Training Women Since 2023</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOUNDER DEEP DIVE */}
      <section style={{ padding: '80px 0', background: '#f9f5ff' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'start' }}>
            <div>
              <h2 style={{ color: '#8a4fff', fontSize: '1rem', letterSpacing: '2px', marginBottom: '15px' }}>THE VISIONARY</h2>
              <h3 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: '20px', color: '#1a1e24' }}>Atsedemariam Mamo</h3>
              <p style={{ color: '#666', fontSize: '1.2rem', marginBottom: '25px', fontStyle: 'italic' }}>
                "I left Geneva to come home. This is where I'm needed."
              </p>
              <p style={{ color: '#555', lineHeight: '1.8', marginBottom: '20px' }}>
                Born and raised in Addis Ababa, Atsedemariam spent 12 years working for the United Nations
                World Tourism Organization, advising countries on sustainable tourism development.
                She visited 47 countries, but always felt called to return home.
              </p>
              <p style={{ color: '#555', lineHeight: '1.8', marginBottom: '20px' }}>
                In 2022, she made the leap. With her savings and a small loan, she founded Encourage Women Ethiopia
                with just 3 guides. Today, she's built a team of 35 women, launched an accredited guide training academy,
                and partnered with 8 women's cooperatives from the Omo Valley to the Danakil.
              </p>
              <p style={{ color: '#555', lineHeight: '1.8' }}>
                "Ethiopia's tourism industry has been dominated by male voices for too long. Our guides are historians,
                mothers, artists, and entrepreneurs. When a traveler books with us, they're investing in Ethiopian women's futures."
              </p>
            </div>
            <div>
              <div style={{
                background: 'url("/images/founder.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '600px',
                borderRadius: '20px',
                boxShadow: '0 20px 40px rgba(138,79,255,0.2)'
              }}></div>
              <div style={{ marginTop: '30px', background: 'white', padding: '30px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                <h4 style={{ fontSize: '1.2rem', fontWeight: 600, marginBottom: '15px', color: '#8a4fff' }}>Recognition</h4>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', gap: '10px' }}>✓ African Women in Tourism 2024 - Leadership Award</li>
                  <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', gap: '10px' }}>✓ Forbes Africa 30 Under 30 (Tourism Category)</li>
                  <li style={{ padding: '10px 0', display: 'flex', gap: '10px' }}>✓ UNWTO Gender Equality Champion 2025</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;